import { render } from "./Otp.vue?vue&type=template&id=2677f95d&scoped=true"
import script from "./Otp.vue?vue&type=script&lang=js"
export * from "./Otp.vue?vue&type=script&lang=js"

import "./Otp.vue?vue&type=style&index=0&id=2677f95d&scoped=true&lang=css"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2677f95d"]])

export default __exports__